/**
 * Hunarvar – Mobile Navigation
 * Oeffnet das eigene Slide-In-Menue ueber den Hamburger-Trigger,
 * Dawns Drawer wird gar nicht mehr gerendert (keine Konflikte).
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var nav = document.getElementById('mobile-nav');
    var overlay = document.getElementById('mobile-nav-overlay');
    var trigger = document.getElementById('mobile-nav-toggle');
    if (!nav || !overlay) return;

    var closeBtn = nav.querySelector('.mobile-nav__close');

    function openNav() {
      nav.classList.add('is-open');
      nav.setAttribute('aria-hidden', 'false');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeNav() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      nav.querySelectorAll('.mobile-nav__link--toggle').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        var s = b.nextElementSibling;
        if (s) s.classList.remove('is-open');
      });
    }

    if (trigger) {
      trigger.addEventListener('click', openNav);
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openNav();
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeNav);
      closeBtn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          closeNav();
        }
      });
    }

    overlay.addEventListener('click', closeNav);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) closeNav();
    });

    var toggles = nav.querySelectorAll('.mobile-nav__link--toggle');
    toggles.forEach(function (btn) {
      function toggleSub() {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        var sub = btn.nextElementSibling;

        toggles.forEach(function (b) {
          if (b !== btn) {
            b.setAttribute('aria-expanded', 'false');
            var s = b.nextElementSibling;
            if (s) s.classList.remove('is-open');
          }
        });

        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (sub) sub.classList.toggle('is-open', !isOpen);
      }
      btn.addEventListener('click', toggleSub);
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleSub();
        }
      });
    });
  });
})();
